import apiClient from "../api/apiClient";

/**
 * Returns the shared axios client (see src/api/apiClient.ts).
 *
 * Historically this hook built a per-component axios instance and installed its interceptors in a
 * `useEffect`. That logic now lives on a single module-level client so it can also be used outside
 * React (TanStack Query fetchers, and later React Router loaders). All existing call sites keep
 * working unchanged: `const api = useApi()` still returns an axios instance, and the returned
 * reference is stable across renders (it's the same singleton), so effect/callback dep lists that
 * include `api` behave exactly as before.
 *
 * `includeAuth` is retained for call-site compatibility but is a no-op — auth rides on the httpOnly
 * `mtc_session` cookie via `withCredentials`, not a JS-attached bearer token.
 */
const useApi = (_includeAuth = true) => apiClient;

export default useApi;
